"use client";

import { Button, Disclosure, Heading, DisclosurePanel } from "react-aria-components";
import { DottedBorder } from "./GradientBorder";
import { clsx } from "clsx";

export function DisclosureList({ items }: { items: { title: string; body: React.ReactNode }[] }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className='tw-flow-root'>
      {items.map((item, itemIndex) => (
        <Disclosure key={itemIndex} className={clsx("tw-group tw-relative tw-isolate", itemIndex === 0 && "-tw-mt-5")}>
          {({ isExpanded }) => (
            <>
              <Heading className='tw-relative tw-z-50'>
                <Button
                  slot='trigger'
                  className='tw-group/trigger tw-text-left tw-w-full tw-text-pretty tw-outline-none focus-visible:tw-outline-focus tw-rounded'
                >
                  {itemIndex !== 0 && <DottedBorder side='inline' />}
                  <div
                    className={clsx(
                      "tw-flex tw-gap-4 motion-safe:tw-transition motion-safe:tw-duration-300 motion-safe:tw-ease-in-out",
                      isExpanded && itemIndex !== 0 && "tw-translate-y-3",
                    )}
                  >
                    <div className={clsx("tw-py-5 tw-type-lg tw-text-black tw-flex-auto")}>{item.title}</div>
                    <div className='tw-flex-none tw-mt-4 tw-size-5 tw-relative tw-transition-colors tw-text-gray-400 group-hover/trigger:tw-text-black'>
                      <svg
                        viewBox='0 0 5 1'
                        aria-hidden
                        className='tw-overflow-visible tw-absolute tw-left-[0.3125rem] tw-top-2 tw-w-[0.3125rem] tw-origin-top-left motion-safe:tw-transition-transform'
                        style={{
                          transform: isExpanded
                            ? `translateY(0.25rem) rotate(-45deg) scaleX(1.3)`
                            : `rotate(45deg) scaleX(1.3)`,
                        }}
                      >
                        <path fill='none' strokeWidth='1.5' stroke='currentColor' d='M0 0L5 0' strokeLinecap='round' />
                      </svg>
                      <svg
                        viewBox='0 0 5 1'
                        aria-hidden
                        className='tw-overflow-visible tw-absolute tw-left-2.5 tw-top-2 tw-w-[0.3125rem] tw-origin-top-right motion-safe:tw-transition-transform'
                        style={{
                          transform: isExpanded
                            ? `translateY(0.25rem) rotate(45deg) scaleX(1.3)`
                            : `rotate(-45deg) scaleX(1.3)`,
                        }}
                      >
                        <path fill='none' strokeWidth='1.5' stroke='currentColor' d='M0 0L5 0' strokeLinecap='round' />
                      </svg>
                    </div>
                  </div>
                </Button>
              </Heading>
              <DisclosurePanel
                className={clsx(
                  "motion-safe:tw-transition-[height,opacity,transform] motion-safe:tw-ease-in-out motion-safe:tw-duration-300 tw-overflow-clip",
                  !isExpanded && "tw-opacity-0",
                  !isExpanded && itemIndex !== 0 && "-tw-translate-y-3",
                )}
                style={{ height: "var(--disclosure-panel-height)" }}
              >
                <div className={clsx("tw-pb-8", itemIndex === 0 ? "tw-pt-2" : "tw-pt-5")}>{item.body}</div>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
}
